export enum Registration {
  APA = 'apa',
  APE = 'ape',
  APS = 'aps',
  APN = 'apn',
}
